// extracted by mini-css-extract-plugin
export default {"sidebarToggler":"SidebarToggler_sidebarToggler__WCQT9"};